import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

class DesignDetailsLoggedOutPane extends React.Component {
    render() {
        return (
            <div className="design-details-logged-out-pane">
                <div className="design-details-logged-out-pane__section design-details-logged-out-pane__section--centered">
                    <div className="design-details-logged-out-pane__logo" />
                </div>
                <div className="design-details-logged-out-pane__section">
                    <h1 className="heading heading--quaternary-sidehead heading--h4 heading--with-divider">
                        <FormattedMessage id="logged-out-pane-customer-title" />
                    </h1>
                    <p>
                        <FormattedMessage id="logged-out-pane-customer-text" />
                    </p>
                    <p>
                        <a
                            href={this.props.urls.customersLearnMore}
                            className="link link--cta link--jumbo"
                        >
                            <FormattedMessage id="logged-out-pane-learn-more" />
                        </a>
                    </p>
                </div>
                <div className="design-details-logged-out-pane__section design-details-logged-out-pane__section--spacious">
                    <h1 className="heading heading--quaternary-sidehead heading--h4 heading--with-divider">
                        <FormattedMessage id="logged-out-pane-designer-title" />
                    </h1>
                    <p>
                        <FormattedMessage id="logged-out-pane-designer-text" />
                    </p>
                    <p>
                        <a
                            href={this.props.urls.designersLearnMore}
                            className="link link--cta link--jumbo"
                        >
                            <FormattedMessage id="logged-out-pane-learn-more" />
                        </a>
                    </p>
                </div>
                <div className="design-details-logged-out-pane__section design-details-logged-out-pane__section--separated">
                    <p>
                        <span>
                            <FormattedMessage id="logged-out-pane-login-title" />
                        </span>
                        &nbsp;
                        <a className="link" href={this.props.urls.login}>
                            <FormattedMessage id="logged-out-pane-login-text" />
                        </a>
                    </p>
                </div>
            </div>
        );
    }
}

DesignDetailsLoggedOutPane.propTypes = {
    urls: PropTypes.object.isRequired,
};

export default DesignDetailsLoggedOutPane;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/design-details-logged-out-pane.jsx